/* Fix for iOS Safari squish content on orientation change */

import { useState, useEffect } from 'react'

const useDimentions = () => {
  const [dimentions, setDimentions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  })
  useEffect(() => {
    const handleResize = () => {
      setDimentions({ height: window.innerHeight, width: window.innerWidth })
    }
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])
  return dimentions
}

export default useDimentions
